import { CircularProgress, Grid, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import { Params, useParams } from "react-router-dom";
import { useGetScenesQuery } from "../../services/scene.service";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { useGetMarksQuery } from "../../services/marks.service";
import { PieChart } from "@mui/x-charts";
import { VTButton, VTTypography, VTUserSelectTable } from "@virtus-tech-repository/virtus-tech-repository";
import { IScene } from "@virtus-tech-repository/virtus-tech-repository/lib/models/scenario.model";
import VTTimelineItem from "@virtus-tech-repository/virtus-tech-repository/lib/components/VTTimelineItem";
import { getImageForSceneOrDefaultImageIfPreviewImageDoesntExist } from "../../utils/getImageForSceneOrDefaultImageIfPreviewImageDoesntExist";
import { useGetScenarioOverviewQuery } from "../../services/scenario.service";
import { useGetScenarioAttemptsQuery, useGetUserScoreQuery } from "../../services/tracking.service";
import { UserAttemptRowObjectType } from "@virtus-tech-repository/virtus-tech-repository/lib/components/VTTableBasic";
import { setCurrentSidePanel, setSelectedUser } from "../../store/slices/current.slice";
import MarksViewItem from "./MarksViewItem";
import ScoresContainer from "./ScoresContainer";
import zIndex from "@mui/material/styles/zIndex";
import NoUser from "../../assets/images/NoScenarios.svg";
import MarksUsersScore from "./MarksUsersScore";

interface IProps {
    drawWidth: number;
}

export default function ViewMarksContainer({ drawWidth }: IProps) {
    const dispatch = useAppDispatch();
    const theme = useTheme();
    const { scenarioId }: Readonly<Params<string>> = useParams();

    const { data: scenes } = useGetScenesQuery(scenarioId ? scenarioId : "");
    const { currentSidePanel, selectedAttempt, selectedUser, currentSidePannelDesiredWidth, selectedVersion } =
        useAppSelector((state) => state.currentReducer);
    const { data: tracking } = useGetScenarioAttemptsQuery({
        scenarioId: selectedVersion ? selectedVersion : scenarioId,
    });
    const [correctSceneList, setCorrectSceneList] = useState<string[]>([]);

    if (selectedUser && scenarioId && selectedAttempt) {
        return (
            <Grid container sx={{ position: "relative", heigth: "100%", zIndex: 10000 }}>
                <MarksUsersScore
                    drawWidth={drawWidth}
                    scenarioId={selectedVersion ? selectedVersion : scenarioId}
                    userId={selectedUser.id}
                    attemptId={selectedAttempt.attemptId}
                />
            </Grid>
        );
    } else {
        return (
            <Grid
                container
                sx={{ height: "100%", backgroundColor: theme.palette.background.default }}
                justifyContent={"center"}
                alignContent={"center"}
            >
                <Grid item xs={12} container justifyContent={"center"}>
                    <VTTypography type={"Heading2"} sx={{ marginBottom: "30px" }}>
                        No user selected
                    </VTTypography>
                </Grid>
                <Grid item>
                    <img src={NoUser} />
                </Grid>{" "}
                <Grid item xs={12} container justifyContent={"center"}>
                    <VTTypography type={"Heading4"} sx={{ marginTop: "20px" }}>
                        Please select a user from the side panel on the left
                    </VTTypography>
                </Grid>
                <Grid item xs={12} container justifyContent={"center"}>
                    <VTButton
                        onClick={() => {
                            dispatch(
                                setCurrentSidePanel({
                                    currentTab: "Users",
                                    currentWidth: currentSidePannelDesiredWidth,
                                    option: undefined,
                                }),
                            );
                        }}
                    >
                        Choose user
                    </VTButton>
                </Grid>
            </Grid>
        );
    }
}
